import './index.scss';

import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';

import Footer from '../../components/Footer';
import Header from '../../components/Header';
import NotFound from '../../components/NotFound';
import Sidebar from '../../components/Sidebar';
import ApprovedTransactions from '../Approved';
import Audit from '../Audit';
import CIN from '../CIN';
import Customers from '../Customers';
import DailySalesRecord from '../DailySalesRecord';
import Dashboard from '../Dashboard';
import DebtRepayment from '../DebtRepayment';
import PriceApproval from '../PriceApproval';
import Pricing from '../Pricing';
import Staffs from '../Staffs';
import UnapprovedTransactions from '../Unapproved';
import WalletPayment from '../WalletPayment';

const Admin = ({ match }) => {
  useEffect(() => {
    document.body.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);
  return (
    <>
      <Header />
      <Sidebar />
      <div id="admin-container" className="admin_container">
        <Switch>
          <Route path={match.url} exact>
            <Dashboard />
          </Route>

          <Route
            path={`${match.url}approved`}
            render={(props) => {
              return <ApprovedTransactions {...props} />;
            }}
          />

          <Route
            path={`${match.url}unapproved`}
            render={(props) => {
              return <UnapprovedTransactions {...props} />;
            }}
          />

          <Route
            path={`${match.url}customers`}
            render={(props) => {
              return <Customers {...props} />;
            }}
          />

          <Route
            path={`${match.url}staffs`}
            render={(props) => {
              return <Staffs {...props} />;
            }}
          />

          <Route
            path={`${match.url}dailysalesrecord`}
            render={(props) => {
              return <DailySalesRecord {...props} />;
            }}
          />

          <Route
            path={`${match.url}audit`}
            render={(props) => {
              return <Audit {...props} />;
            }}
          />

          <Route
            path={`${match.url}debt_repayment_record`}
            render={(props) => {
              return <DebtRepayment {...props} />;
            }}
          />

          <Route
            path={`${match.url}wallet_payment_record`}
            render={(props) => {
              return <WalletPayment {...props} />;
            }}
          />

          <Route
            path={`${match.url}pricing`}
            render={(props) => {
              return <Pricing {...props} />;
            }}
          />

          <Route
            path={`${match.url}approval`}
            render={(props) => {
              return <PriceApproval {...props} />;
            }}
          />

          <Route
            path={`${match.url}createcin`}
            render={(props) => {
              return <CIN {...props} />;
            }}
          />

          <Route path="*">
            <NotFound />
          </Route>
        </Switch>
      </div>
      <Footer />
    </>
  );
};

export default Admin;
